import {
    Expander,
    Header,
    ThemeButton,
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
    TextField
} from "@xapp/components";
import { UserProfile } from "auth/modules/state";
import { StandardLayout } from "layouts";
import React, { FC } from "react";
import DocumentTitle from "react-document-title";
import { Link } from "react-router-dom";

export type SettingsProps = {
    readonly profile: UserProfile
    onLogout(): void;
};

export interface SettingsState {
    readonly profile: UserProfile;
}

export const Settings: FC<SettingsProps> = (props) => {

    const { profile } = props;

    function renderOrganizationAccess(profile: UserProfile) {
        if (profile.roles) {
            return profile.roles.map((role, index) => {
                const roles = role.roles.reduce((prev, current) => {
                    if (prev) {
                        return `${prev}, ${current}`;
                    } else {
                        return `${current}`;
                    }
                }, "");

                return (
                    <TableRow key={index}>
                        <TableCell><Link to={`/${role.organizationId}`}>{role.organizationId}</Link></TableCell>
                        <TableCell>{roles}</TableCell>
                    </TableRow>
                );
            });
        } else {
            return "";
        }
    }

    return (
        <DocumentTitle title="XAPP | Account Settings">
            <StandardLayout>
                <Header>
                    <div>
                        Settings
                    </div>
                    <Expander />
                    <ThemeButton onClick={props.onLogout}>Log out</ThemeButton>
                </Header>
                <TextField margin="dense" type="text" label="Email" name="email" disabled variant="standard" value={profile.email} />
                <h4>Your Organizations</h4>
                <Table>
                    <TableHead>
                        <TableCell>Organization ID</TableCell>
                        <TableCell>Access</TableCell>
                    </TableHead>
                    <TableBody>
                        {renderOrganizationAccess(profile)}
                    </TableBody>
                </Table>
            </StandardLayout>
        </DocumentTitle>
    );
};
